<div *ngIf="canOpenDialog" #dialog id="locationEditorTritonDialog">
    <app-customized-confirmation-box
        *ngIf="showConfirmation$ | async"
        [confirmationData]="confirmationData$ | async"
        (listenConfirmation)="handleConfirmationDialogResult($event)"
    ></app-customized-confirmation-box>
    <div
        class="popupHeader"
        mat-dialog-title
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragBoundary=".cdk-overlay-container"
        (cdkDragEnded)="dragEvent()"
    >
        <span>{{ (title$ | async) | translate }}</span>
        <span class="app-flex-filler"></span>
    </div>
    <app-dynamic-form [formState$]="normalizedFormState$" [form$]="form$"> </app-dynamic-form>
</div>
